import Cookies from "js-cookie";

class CookieManager {
    static get(cookieName) {
        return Cookies.get(cookieName)
    }

    static set(cookieName, cookieValue) {

    }
}

export {CookieManager}
